import { Switch } from "@headlessui/react";

import { cn } from "@/utils/cn";

export function Toggle({
  children,
  toggled,
  setEnabled,
  label,
  disabled,
  className,
  testId,
  badge,
}: {
  toggled: boolean;
  setEnabled: (enabled: boolean) => void;
  label: string;
  disabled: boolean;
  children?: React.ReactNode;
  className?: string;
  testId?: string;
  badge?: React.ReactNode;
}) {
  return (
    <div className={className}>
      <Switch.Group as="div" className="flex items-center justify-between">
        <span className="mr-4 flex flex-grow flex-col">
          <Switch.Label
            as="span"
            className="flex items-center gap-2 text-sm font-medium leading-6 text-gray-900"
            passive
          >
            <span>{label}</span>
            {badge}
          </Switch.Label>
          <Switch.Description as="span" className="mt-1 text-sm text-gray-500">
            {children}
          </Switch.Description>
        </span>
        <Switch
          data-testid={testId}
          checked={toggled}
          onChange={setEnabled}
          className={cn(
            toggled ? "bg-primary" : "bg-gray-200",
            `relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out`
          )}
          disabled={disabled}
        >
          <span
            aria-hidden="true"
            className={cn(
              toggled ? "translate-x-5" : "translate-x-0",
              "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
            )}
          />
        </Switch>
      </Switch.Group>
    </div>
  );
}
